import { render, staticRenderFns } from "./ViewerIssues.vue?vue&type=template&id=1aa7abfc&scoped=true&"
import script from "./ViewerIssues.vue?vue&type=script&lang=js&"
export * from "./ViewerIssues.vue?vue&type=script&lang=js&"
import style0 from "./ViewerIssues.vue?vue&type=style&index=0&id=1aa7abfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7abfc",
  null
  
)

export default component.exports